/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscrepanciesResponse } from '../../models/article-discrepancies-response';
import { KeyType } from '../../models/key-type';

export interface GetArticleDiscrepanciesForArticle$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  articleKey: KeyType;
}

export function getArticleDiscrepanciesForArticle(http: HttpClient, rootUrl: string, params: GetArticleDiscrepanciesForArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, getArticleDiscrepanciesForArticle.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('articleKey', params.articleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleDiscrepanciesResponse>;
    })
  );
}

getArticleDiscrepanciesForArticle.PATH = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies';
